module.exports = __webpack_public_path__ + "media/1alB-lh-lhape'.a47ea7dc.mp3";